import { render, staticRenderFns } from "./stadiumAddress.vue?vue&type=template&id=1ce3ac43&scoped=true"
import script from "./stadiumAddress.vue?vue&type=script&lang=js"
export * from "./stadiumAddress.vue?vue&type=script&lang=js"
import style0 from "./stadiumAddress.vue?vue&type=style&index=0&id=1ce3ac43&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce3ac43",
  null
  
)

export default component.exports